import React from 'react';
import DataNotFound from '../DataNotFound';
import ProjectCardSkeleton from './ProjectCardSkeleton';
import ProjectTypeFilter from './ProjectTypeFilter';
import SortByFilter from './SortByFilter';
import { Link } from 'react-router-dom';
import ProjectCard from '../../layouts/ProjectCard';
import ListViewFilter from './ListViewFilter';
import { useTranslation } from 'react-i18next';
import TableComponent from '../TableComponent';
const ProjectListingRootComponent = ({
  headerText,
  projectLists,
  message,
  slug,
  projectLoading,
  count,
  searchData,
  filterData,
  isDropDownList,
  value,
  setView,
  isView,
  isSortingLoader,
  list,
  isPagination,
  setPagination,
  isListLoader,
}) => {
  const { t } = useTranslation(['projectListingRootComponent', 'common']);

  return (
    <>
      <div className="md:bg-[#ECECEC] md:dark:bg-slate-800 dark:text-slate-200 md:p-7 mt-10 rounded-lg">
        <h3 className="pb-4 mb-6 border-b border-[#B6BDC5] dark:border-slate-600">
          {headerText || 'NA'}
        </h3>
        {projectLists &&
          projectLists?.length === 0 &&
          projectLoading === false &&
          slug === 'dashboard' && (
            <>
              <DataNotFound message={message} />
            </>
          )}

        <div className="flex mb-5 justify-between">
          <ProjectTypeFilter searchData={searchData} filterData={filterData} />
          <div className="flex items-center">
            <div className="mr-2 mt-2 md:mt-0 mb-4 md:mb-0">
              <SortByFilter
                dropdownList={isDropDownList}
                searchData={searchData}
                value={value}
              />
            </div>
            <ListViewFilter setView={setView} isView={isView} />
          </div>
        </div>

        <div className="text-center mb-3 mt-12">
          {isView === 1 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {projectLists && projectLists.length > 0 && (
                <ProjectCard
                  projectLists={projectLists}
                  slug={slug === 'owned-assets' ? slug : 'assets'}
                />
              )}
              {projectLists &&
                projectLists?.length > 6 &&
                slug === 'dashboard' && (
                  <Link
                    to="/assets"
                    className="bg-white dark:bg-[#0B243F] rounded-2xl flex justify-center items-center text-xl font-semibold py-10 px-4 h-full hover:bg-gray-100 cursor-pointer"
                  >
                    {t('common:view_all')}
                  </Link>
                )}
              {projectLists &&
                projectLists?.length === 0 &&
                projectLoading === true && (
                  <ProjectCardSkeleton count={count} />
                )}
            </div>
          ) : isView === 2 ? (
            <TableComponent
              isSortingLoader={isSortingLoader}
              isList={projectLists}
              columnCount={9}
              rowCount={6}
              fetchData={list}
              pagination={isPagination}
              setPagination={setPagination}
              filterData={filterData}
              isListLoader={isListLoader}
              headerSlug={slug}
              slug={'projecListing'}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

export default ProjectListingRootComponent;
